import Swiper from "./../../imports/import-swiper";
export default () => {
  const container = document.querySelector(".big-slider");
  
    if (container) {
      const slides = container.querySelectorAll(".swiper-slide");
      slides.length > 1 ? runSlider() : false;
    }
  

  
  function runSlider() {
    
   
    
      const JournalSlider = new Swiper(container, {
        effect: "fade",
        speed: 600,
        touchStartPreventDefault: false,
        allowTouchMove: true,
        loop: true,
        autoplay: {
          delay: 10000,
        },
        slidesPerView: 1,
        pagination: {
          el: ".big-slider__pagination",
          type: "bullets",
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '"><span></span></span>';
          },
        },
      });
    
  }
};
